<template>
<div>
  <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
  </b-container>
  <div v-else>
    <div class="w-menu">
      <br>
      <b-row class="w-menu-avatar w-cursor-click" @click="gotoProfile()">
        <b-col>
          <b-avatar v-if="currentProfilePicture" 
            size="50px" 
            v-bind:src="currentProfilePicture"
          >
          </b-avatar>
          <b-avatar v-else 
            size="50px" 
            :src="require('@/assets/img/profile-picture.jpg')"
          >
          </b-avatar>
        </b-col>
      </b-row>
      <b-row class="w-menu-under-avatar">
        <b-col style="padding:0" class="text-center">
            <p class="w-menu-name">{{currentUser.firstname}} {{currentUser.lastname}}</p>
            <p class="w-menu-email">{{currentUser.email}}</p>
        </b-col>
      </b-row>
      <hr>
      <b-row class="d-flex flex-row justify-content-center" style="width:100%; margin:0">  
        <div class="justify-content-left">
          <p class="w-menuitem-1" style="top:120px;color:white">{{ translate("information") }} </p>
          <p class="w-menuitem-3 w-cursor-click" style="top:157px" @click="gotoWelcome()">{{ translate("information") }}</p>
          <p class="w-menuitem-2 w-cursor-click" style="top:194px" @click="gotoGeneral()">{{ translate("general") }}</p>
          <p class="w-menuitem-2 w-cursor-click" style="top:231px" @click="gotoContact()">{{ translate("contact") }}</p>
          <p class="w-menuitem-2 w-cursor-click" style="top:268px" @click="gotoSocialMedia()">{{ translate("social media") }}</p>
          <p class="w-menuitem-2 w-cursor-click" style="top:305px" @click="gotoPictures()">{{ translate("gallery") }}</p>
          <p class="w-menuitem-2 w-cursor-click" style="top:342px" @click="gotoWines()">{{ translate("wines") }}</p>
 
          <p class="w-menuitem-3 w-cursor-click" style="top:379px" @click="gotoPreview()">{{ translate("preview") }}</p>  
          <p class="w-menuitem-3 w-cursor-click" style="top:416px" @click="gotoAboutUs()">{{ translate("about us") }}</p>
          <!-- <p class="w-menuitem-3" style="top:416px" @click="logOut()">log off</p> -->
          <p class="w-menuitem-3 w-cursor-click" style="top:453px" @click="logOut()">{{ translate("log off") }}</p>
        </div>
        <div v-if="this.currentPage=='General'" class="w-current-item" style="top:192px"/>
        <div v-if="this.currentPage=='Contact'" class="w-current-item" style="top:229px"/>
        <div v-if="this.currentPage=='SocialMedia'" class="w-current-item" style="top:266px"/>
        <div v-if="this.currentPage=='Pictures'" class="w-current-item" style="top:303px"/>
        <div v-if="this.currentPage=='Wines'" class="w-current-item" style="top:340px"/>
        <div v-if="this.currentPage=='Preview'" class="w-current-item" style="top:377px"/>
        <div v-if="this.currentPage=='AboutUs'" class="w-current-item" style="top:414px"/>
      </b-row>
      <div class="w-menu-footer">
        <p><b><span style="color: rgb(195,147,130)">WYNE</span></b>MAKER</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';

  export default {
    computed : {
      currentUser() {
        return this.$store.state.user
      },
      currentProfilePicture() {
        return this.$store.state.profile_picture
      },
      currentUserID() {
        return this.$store.state.user_id
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentPage() {
        return this.$store.state.current_page
      },
      previousPage() {
        return this.$store.state.previous_page
      }
    },
    data() {
      return {
        isLoading : true,
      }
    },
    async mounted() {
      this.isLoading = false
    },
    methods:{
      gotoProfile() {
        if (this.currentPage != 'Profile') {
          this.$store.commit('setPage','Profile')
          this.$router.push({path:'/Profile', query: {winery_id:this.$route.query.winery_id}})
        }
      },
      gotoHome() {
        this.$store.commit('setPage','Welcome')
        this.$router.push({path:'/Winery/Welcome', query: {winery_id:this.$route.query.winery_id}})
      },
      logOut() {
        this.$store.commit('logout')
        this.$router.push({path:'/'})
      },
      gotoWelcome() {
        this.$store.commit('setPage','Welcome')
        this.$router.push({path:'/Winery/Welcome', query: {winery_id:this.$route.query.winery_id }} );
      },
      gotoGeneral() {
        this.$store.commit('setPage','General')
        this.$router.push({path:'/Winery/General', query: {winery_id:this.$route.query.winery_id }} );
      },
      gotoContact() {
        this.$store.commit('setPage','Contact')
        this.$router.push({path:'/Winery/Contact', query: {winery_id:this.$route.query.winery_id }} );
      },
      gotoSocialMedia() {
        this.$store.commit('setPage','SocialMedia')
        this.$router.push({path:'/Winery/SocialMedia', query: {winery_id:this.$route.query.winery_id }} );
      },
      gotoPictures() {
        this.$store.commit('setPage','Pictures')
        this.$router.push({path:'/Winery/Pictures', query: {winery_id:this.$route.query.winery_id }} );
      },
      gotoWines() {
        this.$store.commit('setPage','Wines')
        this.$router.push({path:'/Winery/Wines', query: {winery_id:this.$route.query.winery_id }} );
      },
      gotoPreview() {
        this.$store.commit('setPage','Preview')
        this.$router.push({path:'/Winery/Preview', query: {winery_id:this.$route.query.winery_id }} );
      },
      gotoAboutUs() {
        this.$store.commit('setPage','AboutUs')
        this.$router.push({path:'/AboutUs', query: {winery_id:this.$route.query.winery_id }});
      },

      translate(string) {
        // console.log("TMP string: ", string, " language: ", this.currentLanguage, " translation: ",translate_word(string, this.currentLanguage) )
        return translate_word(string, this.currentLanguage);
      },  
    }
  }
</script>

<style>
@import url("../assets/styles/wynestyle.css");
</style>

<style scoped>
</style>